// 导出埋点事件
import { clickEvent } from "@/api/header";

const EVENT_MAP = {
    CATEGORY_CLICKED: 0,
    TAG_CLICKED: 1,
    GAME_CLICKED: 2,
};

// 点击目录
export const categoryClicked = (params) => {
    return clickEvent({...params, type: EVENT_MAP.CATEGORY_CLICKED})
};

// 点击标签
export const tagClicked = (params) => {
    return clickEvent({...params, type: EVENT_MAP.TAG_CLICKED})
};

// 点击游戏
export const gameClicked = (game) => {    
    // 添加到本地存储的历史记录
    addToRecentGames(game);
};

// 添加游戏到最近游玩记录
const addToRecentGames = (game) => {
    try {
        const RECENT_GAMES_KEY = 'recent_games';
        const MAX_RECENT_GAMES = 10;
        
        // 获取现有的历史记录
        let recentGames = [];
        const existingData = localStorage.getItem(RECENT_GAMES_KEY);
        if (existingData) {
            recentGames = JSON.parse(existingData);
        }
        
        // 准备要存储的游戏数据
        const gameData = {
            id: game.id,
            name: game.name,
            path: game.slug,
            cover_image: game.cover_image,
            clicked_count: game.clicked_count || 0,
            categories: game.categories || [],
            timestamp: Date.now() // 添加时间戳
        };
        
        // 检查是否已经存在该游戏
        const existingIndex = recentGames.findIndex(item => item.id === game.id);
        
        if (existingIndex !== -1) {
            // 如果已存在，移除旧记录
            recentGames.splice(existingIndex, 1);
        }
        
        // 将新记录添加到数组开头
        recentGames.unshift(gameData);
        
        // 限制数组长度为最多10个
        if (recentGames.length > MAX_RECENT_GAMES) {
            recentGames = recentGames.slice(0, MAX_RECENT_GAMES);
        }
        
        // 保存到localStorage
        localStorage.setItem(RECENT_GAMES_KEY, JSON.stringify(recentGames));
        
        // 触发自定义事件，通知其他组件更新
        window.dispatchEvent(new CustomEvent('recentGamesUpdated', {
            detail: recentGames
        }));
        
    } catch (error) {
        console.error('保存最近游玩记录失败:', error);
    }
};

// 获取最近游玩记录
export const getRecentGames = () => {
    try {
        const RECENT_GAMES_KEY = 'recent_games';
        const existingData = localStorage.getItem(RECENT_GAMES_KEY);
        if (existingData) {
            return JSON.parse(existingData);
        }
        return [];
    } catch (error) {
        console.error('获取最近游玩记录失败:', error);
        return [];
    }
};

// 清空最近游玩记录
export const clearRecentGames = () => {
    try {
        const RECENT_GAMES_KEY = 'recent_games';
        localStorage.removeItem(RECENT_GAMES_KEY);
        window.dispatchEvent(new CustomEvent('recentGamesUpdated', {
            detail: []
        }));
    } catch (error) {
        console.error('清空最近游玩记录失败:', error);
    }
};